import PropTypes from "prop-types";
import adresaPropTypes from "./common/adresaPropTypes";
import osobaPropTypes from "./common/osobaPropTypes";

const propTypes = {
  uloha: PropTypes.shape({
    I_AG_ZIADOST: PropTypes.number,
    KOD_ZIADOSTI: PropTypes.string,

    I_UZ_VYBAVUJE: PropTypes.number,
    N_UZ_VYBAVUJE: PropTypes.string,

    I_STAV_ZIAD: PropTypes.number,
    N_STAV_ZIAD: PropTypes.string,

    D_POD: PropTypes.instanceOf(Date),
    D_VYBAVENIA: PropTypes.instanceOf(Date),
    D_ZMENY: PropTypes.instanceOf(Date),

    ZOSTAVA_DNI: PropTypes.number,

    DetailStavby: PropTypes.shape({
      // detail stavby
      I_TYP_PRACE: PropTypes.number,
      N_TYP_PRACE: PropTypes.string,
      NAZOV_PROJEKTU: PropTypes.string,
      //adresa
      AdresaStavby: adresaPropTypes.adresa,
      // dolezite data
      D_POZADOVANE_VYBAVENIE: PropTypes.instanceOf(Date),
      D_ZAC_STAVBY: PropTypes.instanceOf(Date),
      D_UKONC_STAVBY: PropTypes.instanceOf(Date),
      CIS_ZIAD_ISV: PropTypes.string,
      ID_STAV_ISV: PropTypes.string,
      // stavenisko
      STAVENISKO_NAZOV: PropTypes.string,
      STAVENISKO_VEDUCI: PropTypes.string,
      STAVENISKO_KONTAKT: PropTypes.string,
    }),
    Dovod: PropTypes.shape({
      I_DOVOD: PropTypes.number,
      N_DOVOD: PropTypes.string,
    }),
    Priorita: PropTypes.shape({
      I_PRIORITA: PropTypes.number,
      N_PRIORITA: PropTypes.string,
    }),
    InfoZiadatel: PropTypes.shape({
      L_VLASTNIK: PropTypes.bool,
      Ziadatel: osobaPropTypes.osoba,
      Vlastnik: osobaPropTypes.osoba,
    }),
    OblastZaujmu: PropTypes.shape({
      I_OBLAST: PropTypes.number,
      AdresaStavby: adresaPropTypes.adresa,
    }),
    PrilohyKomentar: PropTypes.shape({
      KOMENTAR: PropTypes.string,
    }),
  }),
};

export default propTypes;
